import { createAction } from '@reduxjs/toolkit'

import { Source, TSourceResponse } from 'types/GlobalSource'

/** A source response and the active source it was fetched for. */
export type TActiveSourcePayload = TSourceResponse & {
  activeSourceId: string
}

// tryGetAllSources
export const getAll = createAction('get_all_sources')
export const getAllSuccess = createAction<{ data: Source[] }>(
  'get_all_sources_success'
)
export const getAllFailed = createAction('get_all_sources_failed')

// tryGetOneSource
export const getOne = createAction('get_one_source')
export const getOneSuccess = createAction<TActiveSourcePayload>(
  'get_one_source_success'
)
export const getOneFailed = createAction('get_one_source_failed')
